<template>
  <base-nav
    v-model="showMenu"
    :class="$style.topNavbar"
    class="navbar-absolute"
    type="white"
    :transparent="true">
    <div
      slot="brand"
      class="navbar-wrapper">
      <div class="navbar-minimize d-inline">
        <sidebar-toggle-button />
      </div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }">
        <button
          type="button"
          class="navbar-toggler"
          @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1" />
          <span class="navbar-toggler-bar bar2" />
          <span class="navbar-toggler-bar bar3" />
        </button>
      </div>
    </div>
    <ul class="navbar-nav">
      <!-- <div class="search-bar input-group">
          <input type="text" v-model="searchQuery" class="form-control nav-search-input"
            placeholder="Search projects or tasks..."
          >
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
      </div> -->
      <base-dropdown
        tag="li"
        :menu-on-right="true"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar">
        <template slot="title">
          <avatar
            :username="fullName"
            background-color="#aaa"
            :size="30"
            color="white" />
          <b class="caret d-none d-lg-block d-xl-block" />
        </template>
        <li>
          <p :class="$style.accountName">{{ fullName }}</p>
        </li>
        <router-link
          class="nav-link"
          tag="li"
          to="/account">
          <a class="nav-item dropdown-item">My Account</a>
        </router-link>
        <div class="dropdown-divider" />
        <li class="nav-link">
          <a
            id="logoutLink"
            @click="logout"
            class="nav-item dropdown-item">Log out</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>

<script>
import Avatar from 'vue-avatar';
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal, BaseAlert } from 'src/components/UI';
import SidebarToggleButton from './SidebarToggleButton';

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
    Avatar,
    BaseAlert,
  },
  props: {
    me: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    fullName() {
      return this.me.full_name || '';
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logout() {
      this.$emit('logout');
    },
  },
};
</script>
<style module>
.topNavbar {
  top: 0px;
}
.accountName {
  font-weight: 600;
  color: black;
  cursor: default;
}
</style>
